import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CanActivateMercado } from './can-activate-mercado';
import { MercadoComponent } from './mercado.component';
import { MercadoFormComponent } from './form';


@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: '',
                canActivateChild: [CanActivateMercado],
                children: [
                    {path: '', component: MercadoComponent},
                    {path: 'novo', component: MercadoFormComponent},
                    {path: ':id', component: MercadoFormComponent}
                ]
            }
        ])
    ],
    exports: [
        RouterModule
    ],
    providers: [
        CanActivateMercado
    ]
})
export class MercadoRoutingModule { }
